/**
 * ABSTRACTION FOR MENU FUNCTIONALITY
 *
 * This way we can decouple any 3rd party library logic from the ui logic.
 */
import { computePosition, flip, autoUpdate, offset, shift } from '@floating-ui/dom';

const defaultOffsetPx = 4;
const defaultShiftPaddingPx = 4;

export default function initialize(activator, content, options = {}) {
  if (!activator || !content) {
    // eslint-disable-next-line no-console
    console.warn('Menu: activator and content must be provided');
    return null;
  }

  const menuOptions = {
    placement: 'bottom-start',
    strategy: 'fixed',
    middleware: [
      offset(options.offsetPx ?? defaultOffsetPx),
      shift({
        padding: options.shiftPaddingPx ?? defaultShiftPaddingPx,
      }),
      flip(),
    ],
    ...Object(options), // this will prevent invalid options param value
  };

  // PRIVATE
  function build() {
    computePosition(activator, content, this.options).then(({ x, y }) => {
      Object.assign(content.style, {
        left: `${x}px`,
        top: `${y}px`,
        width: `${activator.clientWidth || activator.offsetWidth}px`,
      });
    });
  }

  // PUBLIC
  return {
    cleanup: null,
    isOpen: false,
    options: menuOptions,
    show() {
      // eslint-disable-next-line no-param-reassign
      content.style.display = 'inline-block';
      this.cleanup = autoUpdate(activator, content, build.bind(this));
      this.isOpen = true;
    },
    hide() {
      // eslint-disable-next-line no-param-reassign
      content.style.display = '';
      this.isOpen = false;
    },
  };
}
